import React, { useState } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Multiselect } from "multiselect-react-dropdown"; 
 

function Person() {
  const [copied, setCopied] = React.useState(false);
  const [isTrueVal, setIsTrueVal] = React.useState(false);
  const [inputFieldsJp, setInputFieldsJp] = useState({
      type: "JobPosting",
      name: '',
      url:'',
      img:'', 
      company_name:'',
      job_title:'',
      Twitter:'',
      YouTube:'',
      Facebook:'',
      Instagram:'',
      LinkedIn:'',
      Pinterest:'',
      SoundCloud:'',
      Tumblr:'',
      Wikipedia:'',
      Github:'',
      Website:''
  })
  const [inputFieldsJp9, setInputFieldsJp9] = useState([])

  const [selectedVal, setSelectedVal] = useState([{}]);
  const sportsData = [
    { id: 'Facebook', name: 'Facebook' },
    { id: 'Twitter', name: 'Twitter' },
    { id: 'Instagram', name: 'Instagram' },
    { id: 'YouTube', name: 'YouTube' },
    { id: 'LinkedIn', name: 'LinkedIn' },
    { id: 'Pinterest', name: 'Pinterest' },
    { id: 'SoundCloud', name: 'SoundCloud' },
    { id: 'Tumblr', name: 'Tumblr' },
    { id: 'Wikipedia', name: 'Wikipedia' },
    { id: 'Github', name: 'Github' },
    { id: 'Website', name: 'Website' }
  ];
  const urlPatternValidation = URL => {
    const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');    
    return regex.test(URL);
  };
  const handleChange5 = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    if(name === 'url'){
    let isTrueValss = !value || urlPatternValidation(value);
    if(isTrueValss === false)
    {
      setIsTrueVal(true);
    }
    else{
      setIsTrueVal(false);
    }}
    setInputFieldsJp((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }
    }) 
  }
  const handleChange9 = (event) => { 
    let value = event.target.value;
    let name = event.target.name;
    setInputFieldsJp9((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }
    }) 
  }
  const handleChange8 = (newState = {}) => {
    const tempState = { ...selectedVal, ...newState };
    setSelectedVal(tempState); 
  };
  const handleChange4 = (newState = {}) => { 
    setInputFieldsJp9(newState);
    setSelectedVal(newState);
  };
  function MyButton(props) {
    return <button {...props} />
  }
  
  const onCopy = React.useCallback(() => {
    setCopied(true);
    setTimeout(function(){
      setCopied(false);  
    },3000);
  }, []) 
  const sameAs = `"sameAs": [
    `+Object.values(inputFieldsJp9).map((items) =>
    JSON.stringify(items)
  )+`
  ],`;
  const JpIsMyCopy = 
    `<script type="application/ld+json">
    {
      "@context": "https://schema.org/", 
      "@type": "Person", 
      "name": "`+inputFieldsJp.name+`",
      "url": "`+inputFieldsJp.url+`",
      "image": "`+inputFieldsJp.img+`",
      `+sameAs+`
      "jobTitle": "`+inputFieldsJp.job_title+`",
      "worksFor": {
        "@type": "Organization",
        "name": "`+inputFieldsJp.company_name+`"
      }  
    }
    </script><!--PersonList Code Generated by https://w3speedup.com/tools/schema-markup-generator/ -->`; 
    const resetFun = () =>{
      const sws_rows = {
        type: "JobPosting",
        name: '',
        url:'',
        img:'', 
        company_name:'',
        job_title:'',
        Twitter:'',
        YouTube:'',
        Facebook:'',
        Instagram:'',
        LinkedIn:'',
        Pinterest:'',
        SoundCloud:'',
        Tumblr:'',
        Wikipedia:'',
        Github:'',
        Website:''
    };
    setInputFieldsJp(sws_rows);
    setInputFieldsJp9([]);
    setSelectedVal([{}]);
    } 
    
    return (
        <div className='row mt-5 person_row'>
          <div className='col-md-8 ps-0 mb-5 border'>
            <div className='mt-2 mb-2 organization_title'> <b>Person Markup: </b>Social Profile, Job Information </div>
              <div className="row input_fields d-flex">
                <div className="col-md-6">
                  <div className="form-group me-2 mb-2">
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.name} name="name" className="form-control" placeholder="Person's Name" />
                  </div>
                </div>
                <div className="col-md-6 ">
                  <div className="form-group me-2 mb-2">
                    <input type="url" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.url} name="url" className="form-control" placeholder='URL (include the protocol)'/>
                  </div>
                  {isTrueVal && (
                    <div style={{ color: "#F61C04" }}>URL is not valid.</div>
                  )}
                </div>
                <div className="col-md-12">
                  <div className="form-group me-2 mb-2">
                    <input type="url" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.img} name="img" className="form-control"  placeholder='Picture URL'/>
                  </div>
                </div>                  
                <div className="col-md-6 ">
                  <div className="form-group me-2 mb-2">
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.job_title} name="job_title" className="form-control" placeholder='Job Title'/>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group me-2 mb-2">
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsJp.company_name} name="company_name" className="form-control" placeholder='Company'/>
                  </div>
                </div> 
                <div className="col-md-12">
                  <label><h5><i className="fa fa-link"></i> <b> Same As Links</b></h5></label>
                  <div className="form-group me-2 mb-2"> 
                    <label>Select Social PlatForm(s)</label>
                    <Multiselect
                      options={sportsData}
                      name="unitText"
                      displayValue="name"
                      showCheckbox={true}
                      onRemove={(evnt) => handleChange4(evnt)}
                      onSelect={(evnt) => handleChange8(evnt)}
                    />
                  </div>
                </div>  
                <div className='col-md-12'>   
                    { (Object.keys(selectedVal[0]).length> 0) && selectedVal &&  Object.values(selectedVal).map((data)=>{
                      let {name, id} = data; 
                      let valdata = (name==="Twitter")?inputFieldsJp9.Twitter:(name==="Twitter")?inputFieldsJp9.Twitter:(name==="Facebook")?inputFieldsJp9.Facebook:(name==="YouTube")?inputFieldsJp9.YouTube:(name==="Instagram")?inputFieldsJp9.Instagram:(name==="Tumblr")?inputFieldsJp9.Tumblr:
                      (name==="LinkedIn")?inputFieldsJp9.LinkedIn:(name==="Pinterest")?inputFieldsJp9.Pinterest:(name==="SoundCloud")?inputFieldsJp9.SoundCloud:(name==="Wikipedia")?inputFieldsJp9.Wikipedia:(name==="Github")?inputFieldsJp9.Github:(name==="Website")?inputFieldsJp9.Website:'';
                      return (
                        <div className="form-group me-2 mb-2" key={id}>
                          <input type="text" onChange={(evnt) => handleChange9(evnt)} value={valdata} name={name} className="form-control" placeholder={name} />
                        </div>
                      )
                    })
                    }
                </div>  
              </div>
            </div>
          <div className='col-md-4'>
           <div className="card">
              <div className="card-header d-flex">
                <CopyToClipboard onCopy={onCopy} text={JpIsMyCopy} >
                  <MyButton className="btn btn-success"> <i className="fa-solid fa-copy"></i> Copy</MyButton>
                </CopyToClipboard>
                <MyButton className="btn btn-success" onClick={()=>resetFun()}><i className="fa-solid fa-arrows-rotate me-1"></i>Reset</MyButton>
             </div>
             <div className="card-body">
               {JpIsMyCopy}
             </div>
             {copied && 
               <div className="card-footer text-muted">
                 <div className="p-2 btn-success rounded">✅ copied successfully</div>
               </div>
             }
           </div>
          </div>
        </div>
  );
}

export default Person